module.exports = __webpack_public_path__ + "static/media/banner-img.d2e9d5b2.svg";